import { TaiLieu } from "../nhanvien/TaiLieu";

export class ImportFileKPIRequest {
    "file": FormData;
    "thangNam": Date;
    "idDonVi": number;
}
export class DownloadFileKPIRequest {
    "idDonVi": number;
    "thangNam": string
}
export class KPICaNhan {
    "id": number;
    "idNhanVien": number;
    "thangNam": Date;
    "trangThai": number;
    "diemXepLoai": number;
    "diemDanhGia": number;
}
export class NhomKPICaNhan {
    "id": number;
    "ten": string;
    "moTa": string;
    "diemChuan": number;
    "tuDanhGia": number;
    "lanhDaoPhong": number;
    "lanhDaoPhuTrach": number;
    "isValid": boolean = false;
    "chiTiet": Array<ChiTietKPICaNhan>;
    "dsTaiLieu": Array<TaiLieu>;
    "idsTaiLieuXoa": Array<number>;
}
export class ChiTietKPICaNhan {
    "key": number;
    "id": number;
    "idKPI": number;
    "idNhomKPI": number;
    "tenCongViec": string;
    "thoiGianGiao": Date | null;
    "thoiGianYeuCauHoanThanh": Date | null;
    "chatLuong": number | null;
    "tienDo": number | null;
    "ghiChu": string;
    "diemCaNhan": number | null;
    "diemLanhDaoPhong": number | null;
    "diemLanhDaoPhuTrach": number | null;
    "thuTu": number;
    "isTieuDe": number;
    "thuTuStr": string;
    "idCha"?: number;
    "idChaKpi"?: number;
    "idNVGiao"?: number;
    "macDinh"?: boolean;
    "baoCao"?: boolean;
}

export class ChiTietKPITrangChu {
    "key": number;
    "id": number;
    "idKPI": number;
    "idNhomKPI": number;
    "tenCongViec": string;
    "thoiGianGiao": Date;
    "thoiGianYeuCauHoanThanh": Date;
    "ghiChu": string;
    "choSuaThoiGianHT": boolean;
}
export class DanhGiaKPI {
    "id": number;
    "idKPI": number;
    "idNhomKPI": number;
    "idNhanVienDanhGia": number;
    "diem": number;
    "kieuDanhGia": number;
}

export class KPIDuyetResponse {
    "idKPICaNhan": number;
    "idNhanVien": number;
    "thangNam": string;
    "hoTen": string;
    "tenChucVu": string;
    "tuDanhGia": number | null;
    "lanhDaoPhong": number | null;
    "lanhDaoPhuTrach": number | null;
    "diemDanhGia": number | null;
    "lanhDaoDonVi": number | null;
    "trangThai": number;
    "idDonViPhuTrach": number | null;
    "tenDonVi": string;
}

export class LoiViPhamCaNhan {
    "thangNam": Date;
    "id": number;
    "idKPI": number;
    "noiDung": string;
    "chatLuong": number | null;
    "tienDo": number | null;
    "ghiChu": string;
    "diemTru": number | null;
    "rowSpan": number;
}

export class ImportFileKPI {
    "file": FormData;
    "thoiGian": Date;
}